export default __webpack_public_path__ + "static/media/03_DAIF_Eco_04_LLAMA_end.524890fb.jpg";